// import * as localForage from 'localforage';
import { IinstallBase, Iproduct } from '../models';
import { store } from '../index';
import * as types from '../actions/actionTypes';
import moment from 'moment';
import { getProductByID } from './configureStore';

export const addNewProductsFromInstallBases = async (installBases: IinstallBase[]) => {
    const allProductIDs = new Set(installBases.map(install => install.materialID));

    let productsToSave: Iproduct[] = [];

    for (const productID of allProductIDs) {
        const product = await getProductByID(productID);

        if (product) {
            productsToSave.push(product);
        }
    }

    if (productsToSave.length) {
        store.dispatch({
            type: types.GET_ALL_PRODUCTS_SUCCESS,
            payload: productsToSave,
            updateDate: moment().unix()
        });
    }
};
